import { Component, Input, OnChanges, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-insider-relationship",
  // imports: [],
  templateUrl: "./insider-relationship.component.html",
  styleUrl: "./insider-relationship.component.css",
  standalone: false,
})
export class InsiderRelationshipComponent implements OnChanges {
  @Input() isActive: boolean = false;
  selectedTab: number = 0;
  ngOnChanges(changes: SimpleChanges): void {}
}
